<script>
	import {Form} from '../../../helpers/Form/Form'

	export default {
		props: {
			company: Number
		},
		data() {
			return {
				form: new Form({})
			}
		},
		methods: {
			onRequest() {
				this.form
					.submit('post', route('companies.demo_backend', this.company))
					.then((response) => {
                		$('#modal-demo-request').modal('show')
	                }).catch((error) => {
	                    window.toastr.error('Hai già inviato la richiesta per la demo')                    
	                });
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/DashboardBannerDemo.vue